import { Card, CardContent } from "@/components/ui/card";

// ============ SCORE GRID ============

const ScoreCard = ({ label, value, index }) => {
  const getColor = (v) => v < 40 ? 'low' : v < 70 ? 'medium' : 'high';
  const color = getColor(value);
  
  return (
    <div 
      className="metric-card animate-fade-up" 
      style={{ animationDelay: `${index * 50}ms` }}
      data-testid={`score-${label.toLowerCase().replace(/\s/g, '-')}`}
    >
      <div className="flex items-start justify-between mb-3">
        <span className="text-sm text-muted-foreground">{label}</span>
        <span className={`score-indicator score-${color}`}>{value}</span>
      </div>
      <div className="progress-track">
        <div className={`progress-fill progress-fill-${color}`} style={{ width: `${value}%` }} />
      </div>
    </div>
  );
};

const ScoreGrid = ({ scores }) => {
  const labels = {
    procedural_friction: "Procedural Friction",
    documentation_strength: "Documentation Strength",
    insurance_leverage: "Insurance Leverage",
    venue_pressure: "Venue Pressure",
    opposing_counsel_intensity: "Opposing Counsel",
    judge_structure: "Judge Structure",
    jury_volatility: "Jury Volatility",
    financial_recoverability: "Financial Recovery",
    medical_documentation_strength: "Medical Documentation",
    case_economics_pressure: "Case Economics",
    data_confidence: "Data Confidence"
  };
  
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-testid="score-grid">
      {Object.entries(scores).map(([key, value], i) => (
        <ScoreCard key={key} label={labels[key] || key} value={value} index={i} />
      ))}
    </div>
  );
};


export { ScoreCard, ScoreGrid };
